<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="">会员中心</router-link></li>
                <li class="currentNode"><a>上传共享信息</a></li>
            </ul>
            <div class="page-main">
                <person-center-menu></person-center-menu>
                <div class="page-content">
                    <h3>上传共享信息</h3>
                    <el-form label-width="100px" :model="form" :rules="rules" ref="ruleForm" class="form" size="small">
                        <el-form-item label="标题" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="副标题" prop="subTitle">
                            <el-input v-model="form.subTitle"></el-input>
                        </el-form-item>
                        <el-form-item label="内容" prop="content">
                            <!-- 内容编辑器 -->
                            <div style="border: 1px solid #ccc; margin-top: 10px;">
                                <!-- 工具栏 -->
                                <Toolbar
                                    style="border-bottom: 1px solid #ccc"
                                    :editor="editor"
                                    :defaultConfig="toolbarConfig"
                                />
                                <!-- 编辑器 -->
                                <Editor
                                    style="height: 400px; overflow-y: hidden;"
                                    :defaultConfig="editorConfig"
                                    v-model="html"
                                    @onChange="onChange"
                                    @onCreated="onCreated"
                                />
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="onSubmit" class="submitBtn">提交</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import PersonCenterMenu from '@/components/personCenterMenu.vue'
import {
    baseUrl,
    addGongxiang,
    editGongxiang
} from '@services/tokenService.js';
import {
    getPlolicyDetail
} from '@services/indexService.js';
import rulesPattern from '@/assets/utils/rulesPattern.js';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { getCookie } from '@/assets/utils/cookie.js';

export default {
    name:'',
    components: { 
        Editor,
        Toolbar,
        PersonCenterMenu
    },
    data() {
        return {
            editId: null,
            fileList: [],
            form:{
                title: '',
                subTitle: '',
                content: '',
            },
            rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                subTitle: [
                    { required: true, message: '请输入副标题', trigger: 'blur' },
                ],
                content: [
                    { required: true, message: '请输入内容', trigger: 'blur' },
                ],
            },
            editor: null,
            html: '<p></p>',
            toolbarConfig: {
                // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
                // excludeKeys: [ /* 隐藏哪些菜单 */ ],
                excludeKeys: [
                    // 'headerSelect',
                    'fullScreen',
                    'group-more-style',
                    'group-video'
                ]
            },
            editorConfig: {
                MENU_CONF: {},
            }
        }
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
    },
    created() {
        // 鉴权
        if (this.accountId === '') {
            this.$router.push(
                {
                    path: '/layout/login',
                }
            );
        } 
        // 初始化富文本编辑器
        this.initUploadImage();
        // 编辑
        if(this.$route.query.id) {
            this.editId = this.$route.query.id;
            this.getPlolicyDetail(this.editId);
        } 
    },
    methods: {
        initUploadImage() {
            this.editorConfig.MENU_CONF['uploadImage'] = {
                server: baseUrl + '/api/ZhuJingBanXieHui/UploadFile',
                timeout: 5 * 1000, // 5s

                fieldName: 'file',
                // meta: {},
                metaWithUrl: true, // join params to url
                headers: { Accept: 'text/x-json' },

                maxFileSize: 10 * 1024 * 1024, // 10M

                base64LimitSize: 5 * 1024, // insert base64 format, if file's size less than 5kb

                onBeforeUpload(file) {
                    console.log('onBeforeUpload', file)

                    return file // will upload this file
                    // return false // prevent upload
                },
                onProgress(progress) {
                    console.log('onProgress', progress)
                },
                onSuccess(file, res) {
                    console.log('onSuccess', file, res)
                },
                onFailed(file, res) {
                    alert(res.message)
                    console.log('onFailed', file, res)
                },
                onError(file, err, res) {
                    alert(err.message)
                    console.error('onError', file, err, res)
                },
            }
        },
        onSubmit() {
            if(this.form.content == '<p><br></p>') {
                this.$message.warn("内容不可以为空！");
                return false;
            }
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    if (this.editId !== null && this.editId !== '') {
                        this.editGongxiang();
                    } else {
                        this.addGongxiang();
                    }
                } else {
                    return false;
                }
            });
        },
        addGongxiang() {
            let param = {
                Title: this.form.title,
                SubTitle: this.form.subTitle,
                Content: this.editor.getHtml(),
                CreateUserId: this.accountId,
                AccountName: getCookie('loginName'),
                CompanyName: getCookie('companyName'),
                CompanyId: getCookie('companyId')
            };
            addGongxiang(param).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.$message.success("共享信息保存成功！");
                } else {
                    this.$message.error(res.Message);
                }
            })
        },
        editGongxiang() {
            let param = {
                Id: this.editId,
                Title: this.form.title,
                SubTitle: this.form.subTitle,
                Content: this.editor.getHtml(),
                CreateUserId: this.accountId,
                AccountName: getCookie('loginName'),
                CompanyName: getCookie('companyName'),
                CompanyId: getCookie('companyId')
            };
            editGongxiang(param).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.$message.success("共享信息保存成功！");
                } else {
                    this.$message.error(res.Message);
                }
            })

        },
        onCreated(editor) {
            this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
        },
        onChange(editor) {
            this.form.content = editor.getHtml();
        },
        insertTextHandler(content) {
            const editor = this.editor;
            if (editor == null) return;
            editor.insertText(content);
        },
        insertHtmlHandler(content) {
            const editor = this.editor;
            if (editor == null) return;
            editor.setHtml(content);
        },
        printEditorHtml() {
            const editor = this.editor
            if (editor == null) return
            return editor.getHtml();
        },
        disableHandler() {
            const editor = this.editor
            if (editor == null) return
            editor.disable()
        },
        getPlolicyDetail(id) {
            let params = {
                id: id
            };
            getPlolicyDetail(params).then(res => {
                // console.log(res);
                if (res.Code === 1) {
                    this.form.title = res.Data.Title;
                    this.form.subTitle = res.Data.SubTitle;
                    this.form.content = res.Data.Content;
                    this.insertHtmlHandler(this.form.content);
                } else {
                    this.$message.error("共享详情请求失败");
                }
            })
        },
    },
}
</script>

<style scoped>
.page-content {
    padding: 30px;
    min-height: 750px;
}
.page-content h3{
    text-align:center;
    margin-bottom: 20px;
}
.el-select {
    width: 350px;
}
.vertical-nav li a.active {
    border-left: none;
}
.el-button:focus, .el-button:hover {
    color: #fff;
    border-color: #005091;
    background-color: #005091;
}
</style>